import React, { useState, useEffect } from 'react';

import { settings } from './settings.js';
import { endpoints } from './endpoints.js';
import { fetchWithJWT } from './requests.js';

function Simulations() {
  const [simulations, setSimulations] = useState(null);
  const [onlyActive, setOnlyActive] = useState(true);
  const [refresh, setRefresh] = useState(0);

  const [editing, setEditing] = useState(null);
  const [editYaml, setEditYaml] = useState("");
  const [saving, setSaving] = useState(false);

  const [creating, setCreating] = useState(false);
  const [createYaml, setCreateYaml] = useState("");
  const [creatingSaving, setCreatingSaving] = useState(false);

  const createTemplate = "listener:\n  name: new_simulation\n  container:\n    base: \"alpine\"\n  runtime:\n    enable_volumes: \"/keep\"\n";

  useEffect(() => {
    const params = new URLSearchParams({"pagenum": 0, "pagesize": settings.PageSize, "only_active": onlyActive});
    let url = `${endpoints.getSimulations}?${params}`;

    fetchWithJWT(url, "GET", null,
      (data) => {
        setSimulations(Array.isArray(data.Result) ? data.Result : []);
      },
      console.log,
    )
  }, [onlyActive, refresh]);

  const handleOnlyActive = (event) => {
    setOnlyActive(event.target.checked);
  }

  const openEdit = (sim) => {
    setEditing(sim);
    setEditYaml(sim.SimulationDefinition);
  }

  const closeEdit = () => {
    setEditing(null);
    setEditYaml("");
    setSaving(false);
  }

  const openCreate = () => {
    setCreating(true);
    setCreateYaml(createTemplate);
  }

  const closeCreate = () => {
    setCreating(false);
    setCreateYaml("");
    setCreatingSaving(false);
  }

  const saveCreate = () => {
    setCreatingSaving(true);
    fetchWithJWT(endpoints.postSimulations, "POST", createYaml,
      () => {
        setCreatingSaving(false);
        closeCreate();
        setRefresh(refresh + 1);
      },
      (err) => {
        console.log(err);
        setCreatingSaving(false);
      },
    )
  }

  const saveEdit = () => {
    if (editing === null) {
      return;
    }

    let url = `${endpoints.putSimulation}/${editing.SimulationName}`;
    let body = {"SimulationDefinition": btoa(unescape(encodeURIComponent(editYaml)))};

    setSaving(true);
    fetchWithJWT(url, "PUT", body,
      () => {
        setSaving(false);
        closeEdit();
        setRefresh(refresh + 1);
      },
      (err) => {
        console.log(err);
        setSaving(false);
      },
    )
  }

  function makeDefinition(definition) {
    return (
      <details>
        <summary>Show</summary>
        <pre>{definition}</pre>
      </details>
    )
  }

  return (
    <div className="container block">
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <h2 className="title has-text-weight is-4 honey-text-font-family honey-text-common">
              Simulations
            </h2>
          </div>
        </div>
        <div className="level-right">
          <div className="level-item">
            <button className="button honey-button" onClick={openCreate}>
              Create Simulation
            </button>
          </div>
          <div className="level-item">
            <label className="checkbox">
              <input type="checkbox" checked={onlyActive} onChange={handleOnlyActive} />
              <span className="honey-text-common">Only Active</span>
            </label>
          </div>
        </div>
      </div>
      {simulations === null ? null : (
        <div className="table-container honey-round-border honey-table-overflow">
          <table className="table is-fullwidth">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Active</th>
                <th>Definition</th>
                <th className="has-text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {simulations.map((sim) => (
                <tr key={sim.ID}>
                  <td>{sim.ID}</td>
                  <td className="honey-text-font-monospace">{sim.SimulationName}</td>
                  <td>{sim.Active ? "TRUE" : "FALSE"}</td>
                  <td>{makeDefinition(sim.SimulationDefinition)}</td>
                  <td className="has-text-right">
                    <button className="button is-small honey-button" onClick={() => {openEdit(sim)}}>
                      Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {editing !== null ? (
        <div className="modal is-active">
          <div className="modal-background" onClick={closeEdit}></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Edit Simulation: {editing.SimulationName}</p>
              <button className="delete" aria-label="close" onClick={closeEdit}></button>
            </header>
            <section className="modal-card-body">
              <textarea
                className="textarea honey-input-focus-color"
                rows="15"
                value={editYaml}
                onChange={(event) => {setEditYaml(event.target.value)}}
              ></textarea>
            </section>
            <footer className="modal-card-foot">
              <button className={`button honey-button ${saving ? "is-loading" : ""}`} onClick={saveEdit} disabled={saving}>
                Save
              </button>
              <button className="button" onClick={closeEdit} disabled={saving}>
                Cancel
              </button>
            </footer>
          </div>
        </div>
      ) : null}

      {creating ? (
        <div className="modal is-active">
          <div className="modal-background" onClick={closeCreate}></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <p className="modal-card-title">Create Simulation</p>
              <button className="delete" aria-label="close" onClick={closeCreate}></button>
            </header>
            <section className="modal-card-body">
              <textarea
                className="textarea honey-input-focus-color"
                rows="15"
                value={createYaml}
                onChange={(event) => {setCreateYaml(event.target.value)}}
              ></textarea>
            </section>
            <footer className="modal-card-foot">
              <button className={`button honey-button ${creatingSaving ? "is-loading" : ""}`} onClick={saveCreate} disabled={creatingSaving}>
                Save
              </button>
              <button className="button" onClick={closeCreate} disabled={creatingSaving}>
                Cancel
              </button>
            </footer>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Simulations;
